import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import VModal from 'vue-js-modal'
import VeeValidate from 'vee-validate'
import vSelect from 'vue-select'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css';
import auth from './auth'
import Axios from 'axios'
import VueCookies from 'vue-cookies'
import Numeral from 'numeral';

import Home from './components/Home.vue'
import Login from './components/Login.vue'
import MacPools from './components/MacPools.vue'
import Users from './components/Users.vue'
import Roles from './components/Roles.vue'
import Rights from './components/Rights.vue'
import Protocol from './components/Protocol.vue'
import Settings from './components/Settings.vue'
import PoolGroups from './components/PoolGroup.vue'
import UserPreferences from './components/common/users/UserPreferences'

import './cookieProxy';
import '@fortawesome/fontawesome-free/css/all.css'
import "material-design-icons-iconfont"

Vue.use(require('vue-cookies'));
Vue.use(require('numeral'));

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VModal, {dialog: true, injectModalsContainer: true, dynamic: true});
Vue.use(VeeValidate);
Vue.use(Vuetify);
Vue.use(Axios);
Vue.use(VueCookies);
Vue.use(Numeral);

Vue.component('v-select', vSelect);

const routes = [
    {path: '', name: 'Home', component: Home, beforeEnter: requireLogin},
    {path: '/', name: 'Home', component: Home, beforeEnter: requireLogin},
    {
        path: '/macpools',
        name: 'MAC-Pools',
        component: MacPools,
        meta: {breadcrumb: [{name: 'MAC-Pool'}], right: 'PoolGroupRead', alternativeRight: "PoolModify"},
        beforeEnter: requireAuth
    },
    {
        path: '/poolgroups',
        name: 'Pool Groups',
        component: PoolGroups,
        meta: {breadcrumb: [{name: 'PoolGroups'}], right: 'PoolGroupRead', alternativeRight: "PoolGroupModify"},
        beforeEnter: requireAuth
    },
    {path: '/users', component: Users, meta: {right: 'UserRead'}, beforeEnter: requireAuth},
    {
        path: '/roles',
        component: Roles,
        name: 'Roles',
        meta: {breadcrumb: [{name: 'Roles'}], right: 'RoleRead'},
        beforeEnter: requireAuth
    },
    {
        path: '/rights',
        component: Rights,
        name: 'Rights',
        meta: {breadcrumb: [{name: 'Rights'}], right: 'RightRead'},
        beforeEnter: requireAuth
    },
    {
        path: '/protocol',
        component: Protocol,
        meta: {right: 'ProtocolEntryRead', alternativeRight: 'ProtocolEntryReadAll'},
        beforeEnter: requireAuth
    },
    {
        path: '/settings',
        component: Settings,
        meta: {right: 'SettingRead', alternativeRight: "SystemSettingRead"},
        beforeEnter: requireAuth
    },

    {path: '/login', component: Login},
    {
        path: '/logout', beforeEnter(to, from, next) {
            auth.logout();
            next('login')
        }
    },

    {
        path: '/userpreferences',
        component: UserPreferences,
        beforeEnter: requireLogin
    },
];

const router = new VueRouter({
    routes
});

VueCookies.config('20MIN');

/* eslint-disable no-new */
new Vue({
    router,
    render: h => h(App),
    iconfont: 'fa'
}).$mount('#app');


function requireAuth(to, from, next) {
    if (!auth.loggedIn()) {
        next({
            path: '/login',
            query: {redirect: to.fullPath}
        })
    } else {
        let rightList = JSON.parse(window.$cookies.get("userRights"));

        if (rightList != null) {

            let rightAvailable = false;

            rightList.forEach(right => {
                if (right.right === to.meta.right || (to.meta.alternativeRight && right.right === to.meta.alternativeRight)) {
                    rightAvailable = true;
                }
            });

            if (!rightAvailable) {
                next({
                    path: from.fullPath,
                    query: {redirect: to.fullPath}
                });

                window.$router.replace(this.$route.query.redirect || '/');
            } else {
                next();
            }
        } else {

            next({
                path: 'from.fullPath',
                query: {redirect: to.fullPath}
            });
        }
    }
}

function requireLogin(to, from, next) {
    if (!auth.loggedIn()) {
        next({
            path: '/login',
            query: {redirect: to.fullPath}
        })
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./src/main.js